import { isNative } from './platform';

/**
 * Tap feedback on answer submit. Light for correct, medium for wrong.
 * Silent failure if the plugin errors — haptics are non-essential.
 */
export async function notifyAnswer(isCorrect: boolean): Promise<void> {
  if (!isNative()) return;
  try {
    const { Haptics, ImpactStyle } = await import('@capacitor/haptics');
    await Haptics.impact({ style: isCorrect ? ImpactStyle.Light : ImpactStyle.Medium });
  } catch {
    // intentionally swallow — haptics are non-essential
  }
}

/**
 * Success notification pattern on achievement unlock.
 */
export async function notifyAchievement(): Promise<void> {
  if (!isNative()) return;
  try {
    const { Haptics, NotificationType } = await import('@capacitor/haptics');
    await Haptics.notification({ type: NotificationType.Success });
  } catch {
    // intentionally swallow
  }
}
